var app = angular.module('leonardo');

var TemplateTriggerService = function(BaseRestService) {
  var service = new BaseRestService('templates-trigger', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('templates-trigger', false, function(template) {
      template.addRestangularMethod('changeStatus', 'post', 'change-status');
      template.addRestangularMethod('assignUsers', 'post', 'assign-users');
      template.addRestangularMethod('assignVendors', 'post', 'assign-vendors');
      return template;
    });
  });

  service.bulkObject = function(account) {
    return {
      account: account,
      recurrence: {},
      attachments: [],
      fields: {}
    };
  };

  return service;
};

app.factory('TemplateTriggerService', ['BaseRestService', TemplateTriggerService]);
